import { EDCDDActionAuditType, EEcdd2TransactionType, EEcddActingType, EEcddAttachmentDocType, EEcddEntityType, EEcddFormCAndU6FileNameType, EEcddFormStatus, EEcddGender, EEcddIdentityType, EEcddIdentityType2, EEcddLegalEntityType, EEcddPropertyType, EEcddRepresentType, EEcddResidentialStatus, EEcddStatus, EEcddTransactionType } from '../enums/ecdd.enum';
import { OptionDescription } from '../types/option.type';
import { StatusRecord } from '../types/status.type';

export const ECDD_STATUSES: StatusRecord<EEcddStatus> = {
  [EEcddStatus.draft]: {
    id: EEcddStatus.draft,
    name: 'Draft',
    filterName: 'Draft',
    showOnFilter: true,
    class: 'status-box-default',
    canSubmit: true,
    canEdit: true,
    canDelete: true,
    canEditPropertyAddress: true,
  },
  [EEcddStatus.rework]: {
    id: EEcddStatus.rework,
    name: 'Rework',
    filterName: 'Rework',
    showOnFilter: true,
    class: 'status-box-brilliant-azure',
    canEdit: true,
    canDelete: false,
    canEditPropertyAddress: true,
  },
  [EEcddStatus.attachmentProcessing]: {
    id: EEcddStatus.attachmentProcessing,
    name: 'Attachments Processing',
    filterName: 'Attachments Processing',
    showOnFilter: true,
    class: 'status-box-warning',
    canSubmit: true,
    canEdit: false,
    canDelete: false,
  },
  [EEcddStatus.attachmentError]: {
    id: EEcddStatus.attachmentError,
    name: 'Attachments Error',
    filterName: 'Attachments Error',
    showOnFilter: true,
    class: 'status-box-danger',
    canSubmit: true,
    canEdit: false,
    canDelete: false,
    canEditPropertyAddress: true,
  },
  [EEcddStatus.clientSigned]: {
    id: EEcddStatus.clientSigned,
    name: 'Client Signed',
    filterName: 'Client Signed',
    showOnFilter: false,
    class: 'status-box-purple',
    canEdit: true,
    canDelete: false,
  },
  [EEcddStatus.submitted]: {
    id: EEcddStatus.submitted,
    name: 'Pending Approval',
    filterName: 'Pending Approval',
    showOnFilter: true,
    class: 'status-box-warning',
    canEdit: false,
    canDelete: false,
    canRework: true,
    canEditPropertyAddress: true,
  },
  [EEcddStatus.approved]: {
    id: EEcddStatus.approved,
    name: 'Manually Approved',
    filterName: 'Manually Approved',
    showOnFilter: true,
    class: 'status-box-success',
    canEdit: false,
    canEditProjectInfo: true,
    canDelete: false,
    canRework: true,
    canEditPropertyAddress: true,
  },
  [EEcddStatus.autoApproved]: {
    id: EEcddStatus.autoApproved,
    name: 'Approved',
    filterName: 'Approved',
    showOnFilter: true,
    class: 'status-box-success',
    canEdit: false,
    canEditProjectInfo: true,
    canDelete: false,
    canRework: true,
    canEditPropertyAddress: true,
  },
  [EEcddStatus.rejected]: {
    id: EEcddStatus.rejected,
    name: 'Rejected',
    filterName: 'Rejected',
    showOnFilter: true,
    class: 'status-box-danger',
    canEdit: false,
    canDelete: false,
    canEditPropertyAddress: true,
  },
};

export const ECDD_TRANSACTION_TYPE_OPTIONS: Record<EEcddTransactionType, OptionDescription<EEcddTransactionType>> = {
  [EEcddTransactionType.Rental]: {
    id: EEcddTransactionType.Rental,
    value: EEcddTransactionType.Rental,
    viewValue: 'Rental',
  },
  [EEcddTransactionType.Sales]: {
    id: EEcddTransactionType.Sales,
    value: EEcddTransactionType.Sales,
    viewValue: 'Sale & Purchase',
  },
};

export const ECDD_IDENTIFY_TYPE_OPTIONS: Record<EEcddIdentityType, OptionDescription<EEcddIdentityType>> = {
  [EEcddIdentityType.NRIC]: {
    id: EEcddIdentityType.NRIC,
    value: EEcddIdentityType.NRIC,
    viewValue: 'NRIC',
  },
  [EEcddIdentityType.Passport]: {
    id: EEcddIdentityType.Passport,
    value: EEcddIdentityType.Passport,
    viewValue: 'Passport',
  },
  [EEcddIdentityType.WorkPass]: {
    id: EEcddIdentityType.WorkPass,
    value: EEcddIdentityType.WorkPass,
    viewValue: 'Work Pass',
  },
  [EEcddIdentityType.Others]: {
    id: EEcddIdentityType.Others,
    value: EEcddIdentityType.Others,
    viewValue: 'Others',
  },
};
export const ECDD_REPRESENT_TYPE_OPTIONS: Record<EEcddRepresentType, OptionDescription<EEcddRepresentType>> = {
  [EEcddRepresentType.buyer]: {
    id: EEcddRepresentType.buyer,
    value: EEcddRepresentType.buyer,
    viewValue: 'Buyer',
  },
  [EEcddRepresentType.seller]: {
    id: EEcddRepresentType.seller,
    value: EEcddRepresentType.seller,
    viewValue: 'Seller',
  },
  [EEcddRepresentType.landlord]: {
    id: EEcddRepresentType.landlord,
    value: EEcddRepresentType.landlord,
    viewValue: 'Landlord',
  },
  [EEcddRepresentType.tenant]: {
    id: EEcddRepresentType.tenant,
    value: EEcddRepresentType.tenant,
    viewValue: 'Tenant',
  },
};

export const ECDD_ACTING_TYPE_OPTIONS: Record<EEcddActingType, OptionDescription<EEcddActingType>> = {
  [EEcddActingType.Self]: {
    id: EEcddActingType.Self,
    value: EEcddActingType.Self,
    viewValue: 'Client is acting for himself/herself',
  },
  [EEcddActingType.AnotherIndividual]: {
    id: EEcddActingType.AnotherIndividual,
    value: EEcddActingType.AnotherIndividual,
    viewValue: 'Client is acting on behalf of another individual',
  },
  [EEcddActingType.AnotherCompany]: {
    id: EEcddActingType.AnotherCompany,
    value: EEcddActingType.AnotherCompany,
    viewValue: 'Client is acting on behalf of a corporate or legal arrangement',
  },
};

export const UCP_ECDD_ACTING_TYPE_OPTIONS: Record<EEcddActingType, OptionDescription<EEcddActingType>> = {
  [EEcddActingType.Self]: {
    id: EEcddActingType.Self,
    value: EEcddActingType.Self,
    viewValue: 'UCP is acting for himself/herself',
  },
  [EEcddActingType.AnotherIndividual]: {
    id: EEcddActingType.AnotherIndividual,
    value: EEcddActingType.AnotherIndividual,
    viewValue: 'UCP is acting on behalf of another individual',
  },
  [EEcddActingType.AnotherCompany]: {
    id: EEcddActingType.AnotherCompany,
    value: EEcddActingType.AnotherCompany,
    viewValue: 'UCP is acting on behalf of a corporate or legal arrangement',
  },
};

export const AUDIT_ECDD_ACTING_TYPE_OPTIONS: Record<EEcddActingType, OptionDescription<EEcddActingType>> = {
  [EEcddActingType.Self]: {
    id: EEcddActingType.Self,
    value: EEcddActingType.Self,
    viewValue: 'Client / UCP is acting for himself/herself',
  },
  [EEcddActingType.AnotherIndividual]: {
    id: EEcddActingType.AnotherIndividual,
    value: EEcddActingType.AnotherIndividual,
    viewValue: 'Client / UCP is acting on behalf of another individual',
  },
  [EEcddActingType.AnotherCompany]: {
    id: EEcddActingType.AnotherCompany,
    value: EEcddActingType.AnotherCompany,
    viewValue: 'Client / UCP is acting on behalf of a corporate or legal arrangement',
  },
};


export const ECDD_ENTITY_TYPE_OPTIONS: Record<EEcddEntityType, OptionDescription<EEcddEntityType>> = {
  [EEcddEntityType.LimitedPartnership]: {
    id: EEcddEntityType.LimitedPartnership,
    value: EEcddEntityType.LimitedPartnership,
    viewValue: 'Limited Partnership',
  },
  [EEcddEntityType.LimitedLiabilityPartnership]: {
    id: EEcddEntityType.LimitedLiabilityPartnership,
    value: EEcddEntityType.LimitedLiabilityPartnership,
    viewValue: 'Limited Liability Partnership',
  },
  [EEcddEntityType.Company]: {
    id: EEcddEntityType.Company,
    value: EEcddEntityType.Company,
    viewValue: 'Limited Partnership',
  },
  [EEcddEntityType.Corporation]: {
    id: EEcddEntityType.Corporation,
    value: EEcddEntityType.Corporation,
    viewValue: 'Corporation',
  },
  [EEcddEntityType.Trust]: {
    id: EEcddEntityType.Trust,
    value: EEcddEntityType.Trust,
    viewValue: 'Trust',
  },
  [EEcddEntityType.others]: {
    id: EEcddEntityType.others,
    value: EEcddEntityType.others,
    viewValue: 'Others',
  },
};

export const ECDD_PROPERTY_TYPE_OPTIONS: Record<EEcddPropertyType, OptionDescription<EEcddPropertyType>> = {
  [EEcddPropertyType.HDB]: {
    id: EEcddPropertyType.HDB,
    value: EEcddPropertyType.HDB,
    viewValue: 'HDB flat/room',
  },
  [EEcddPropertyType.CONDO]: {
    id: EEcddPropertyType.CONDO,
    value: EEcddPropertyType.CONDO,
    viewValue: 'Condo',
  },
  [EEcddPropertyType.LANDED]: {
    id: EEcddPropertyType.LANDED,
    value: EEcddPropertyType.LANDED,
    viewValue: 'Landed Property',
  },
  [EEcddPropertyType.OTHER]: {
    id: EEcddPropertyType.OTHER,
    value: EEcddPropertyType.OTHER,
    viewValue: 'Others',
  },
};

export const ECDD2_TRANSACTION_TYPE_OPTIONS: Record<EEcdd2TransactionType, OptionDescription<EEcdd2TransactionType>> = {
  [EEcdd2TransactionType.RESALE]: {
    id: EEcdd2TransactionType.RESALE,
    value: EEcdd2TransactionType.RESALE,
    viewValue: 'Resale / Rental',
  },
  [EEcdd2TransactionType.PROJECTSALE]: {
    id: EEcdd2TransactionType.PROJECTSALE,
    value: EEcdd2TransactionType.PROJECTSALE,
    viewValue: 'Project',
  },
};


export const ECDD_GENDER_OPTIONS: Record<EEcddGender, OptionDescription<EEcddGender>> = {
  [EEcddGender.M]: {
    id: EEcddGender.M,
    value: EEcddGender.M,
    viewValue: 'Male',
  },
  [EEcddGender.F]: {
    id: EEcddGender.F,
    value: EEcddGender.F,
    viewValue: 'Female',
  },
  [EEcddGender.U]: {
    id: EEcddGender.U,
    value: EEcddGender.U,
    viewValue: 'Unknown',
  },
};
export const ECDD_IDENTIFY_TYPE_OPTIONS_2: Record<EEcddIdentityType2, OptionDescription<EEcddIdentityType2>> = {
  [EEcddIdentityType2.NRIC]: {
    id: EEcddIdentityType2.NRIC,
    value: EEcddIdentityType2.NRIC,
    viewValue: 'Identity card',
  },
  [EEcddIdentityType2.Passport]: {
    id: EEcddIdentityType2.Passport,
    value: EEcddIdentityType2.Passport,
    viewValue: 'Passport',
  },
  [EEcddIdentityType2.WorkPermit]: {
    id: EEcddIdentityType2.WorkPermit,
    value: EEcddIdentityType2.WorkPermit,
    viewValue: 'Work Permit',
  },
  [EEcddIdentityType2.Other]: {
    id: EEcddIdentityType2.Other,
    value: EEcddIdentityType2.Other,
    viewValue: 'Others',
  },
  [EEcddIdentityType2.FIN]: {
    id: EEcddIdentityType2.FIN,
    value: EEcddIdentityType2.FIN,
    viewValue: 'FIN',
  },
  [EEcddIdentityType2.UEN]: {
    id: EEcddIdentityType2.UEN,
    value: EEcddIdentityType2.UEN,
    viewValue: 'UEN',
  },
};

export const ECDD_RESIDENTIAL_STATUS_OPTIONS: Record<EEcddResidentialStatus, OptionDescription<EEcddResidentialStatus>> = {
  [EEcddResidentialStatus.A]: {
    id: EEcddResidentialStatus.A,
    value: EEcddResidentialStatus.A,
    viewValue: 'Alien',
  },
  [EEcddResidentialStatus.C]: {
    id: EEcddResidentialStatus.C,
    value: EEcddResidentialStatus.C,
    viewValue: 'Citizen',
  },
  [EEcddResidentialStatus.P]: {
    id: EEcddResidentialStatus.P,
    value: EEcddResidentialStatus.P,
    viewValue: 'PR',
  },

  [EEcddResidentialStatus.U]: {
    id: EEcddResidentialStatus.U,
    value: EEcddResidentialStatus.U,
    viewValue: 'Unknown',
  },
  [EEcddResidentialStatus.N]: {
    id: EEcddResidentialStatus.N,
    value: EEcddResidentialStatus.N,
    viewValue: 'Not Applicable',
  },
  [EEcddResidentialStatus.F]: {
    id: EEcddResidentialStatus.F,
    value: EEcddResidentialStatus.F,
    viewValue: 'Foreigner',
  },
};

export const ECDD_LEGAL_ENTITY_TYPE_OPTIONS: Record<EEcddLegalEntityType, OptionDescription<EEcddLegalEntityType>> = {
  [EEcddLegalEntityType.LIMITED_PARTNERSHIP]: {
    id: EEcddLegalEntityType.LIMITED_PARTNERSHIP,
    value: EEcddLegalEntityType.LIMITED_PARTNERSHIP,
    viewValue: 'Limited Partnership',
  },
  [EEcddLegalEntityType.LIMITED_LIABILITY_PARTNERSHIP]: {
    id: EEcddLegalEntityType.LIMITED_LIABILITY_PARTNERSHIP,
    value: EEcddLegalEntityType.LIMITED_LIABILITY_PARTNERSHIP,
    viewValue: 'Limited Liability Partnership',
  },
  [EEcddLegalEntityType.COMPANY]: {
    id: EEcddLegalEntityType.COMPANY,
    value: EEcddLegalEntityType.COMPANY,
    viewValue: 'Company',
  },
  [EEcddLegalEntityType.TRUST]: {
    id: EEcddLegalEntityType.TRUST,
    value: EEcddLegalEntityType.TRUST,
    viewValue: 'Trust',
  },
  [EEcddLegalEntityType.CORPORATION]: {
    id: EEcddLegalEntityType.CORPORATION,
    value: EEcddLegalEntityType.CORPORATION,
    viewValue: 'Corporation',
  },
  [EEcddLegalEntityType.OTHER]: {
    id: EEcddLegalEntityType.OTHER,
    value: EEcddLegalEntityType.OTHER,
    viewValue: 'Others',
  },
};

export const ECDD_FORM_STATUSES: StatusRecord<EEcddFormStatus> = {
  [EEcddFormStatus.PENDING_APPROVAL]: {
    id: EEcddFormStatus.PENDING_APPROVAL,
    name: 'Pending Approval',
    class: 'status-box-warning',
  },
  [EEcddFormStatus.APPROVED]: {
    id: EEcddFormStatus.APPROVED,
    name: 'Approved',
    class: 'status-box-success',
  },
  [EEcddFormStatus.REJECTED]: {
    id: EEcddFormStatus.REJECTED,
    name: 'Rejected',
    class: 'status-box-danger',
  },
};



export const ECDD_FILE_NAME_TYPE_OPTIONS: Record<EEcddFormCAndU6FileNameType, OptionDescription<EEcddFormCAndU6FileNameType>> = {
  [EEcddFormCAndU6FileNameType.BANK_STATEMENTS]: {
    id: EEcddFormCAndU6FileNameType.BANK_STATEMENTS,
    value: EEcddFormCAndU6FileNameType.BANK_STATEMENTS,
    viewValue: 'Bank Statements',
    section: 'B',
  },
  [EEcddFormCAndU6FileNameType.CPF_STATEMENT]: {
    id: EEcddFormCAndU6FileNameType.CPF_STATEMENT,
    value: EEcddFormCAndU6FileNameType.CPF_STATEMENT,
    viewValue: 'CPF Statement',
    section: 'B',
  },
  [EEcddFormCAndU6FileNameType.SALE_PURCHASE_AGREEMENT_PREVIOUS_PROPERTY]: {
    id: EEcddFormCAndU6FileNameType.SALE_PURCHASE_AGREEMENT_PREVIOUS_PROPERTY,
    value: EEcddFormCAndU6FileNameType.SALE_PURCHASE_AGREEMENT_PREVIOUS_PROPERTY,
    viewValue: 'Sale & Purchase Agreement of previous property',
    section: 'B',
  },
  [EEcddFormCAndU6FileNameType.LOAN_APPROVAL_LETTER]: {
    id: EEcddFormCAndU6FileNameType.LOAN_APPROVAL_LETTER,
    value: EEcddFormCAndU6FileNameType.LOAN_APPROVAL_LETTER,
    viewValue: 'Loan Approval Letter',
    section: 'B',
  },
  [EEcddFormCAndU6FileNameType.INVESTMENT_PORTFOLIO_STATEMENTS]: {
    id: EEcddFormCAndU6FileNameType.INVESTMENT_PORTFOLIO_STATEMENTS,
    value: EEcddFormCAndU6FileNameType.INVESTMENT_PORTFOLIO_STATEMENTS,
    viewValue: 'Investment Portfolio Statements',
    section: 'B',
  },
  [EEcddFormCAndU6FileNameType.GIFT_DEED_INHERITANCE_DOCUMENTS]: {
    id: EEcddFormCAndU6FileNameType.GIFT_DEED_INHERITANCE_DOCUMENTS,
    value: EEcddFormCAndU6FileNameType.GIFT_DEED_INHERITANCE_DOCUMENTS,
    viewValue: 'Gift Deed / Inheritance Documents',
    section: 'B',
  },
  [EEcddFormCAndU6FileNameType.OTHERS_CHECKBOX_2]: {
    id: EEcddFormCAndU6FileNameType.OTHERS_CHECKBOX_2,
    value: EEcddFormCAndU6FileNameType.OTHERS_CHECKBOX_2,
    viewValue: 'Others',
    section: 'B',
  },
  [EEcddFormCAndU6FileNameType.COMPANY_FINANCIAL_STATEMENTS]: {
    id: EEcddFormCAndU6FileNameType.COMPANY_FINANCIAL_STATEMENTS,
    value: EEcddFormCAndU6FileNameType.COMPANY_FINANCIAL_STATEMENTS,
    viewValue: 'Company Financial Statements',
    section: 'C',
  },
  [EEcddFormCAndU6FileNameType.EMPLOYMENT_LETTER_PAY_SLIPS]: {
    id: EEcddFormCAndU6FileNameType.EMPLOYMENT_LETTER_PAY_SLIPS,
    value: EEcddFormCAndU6FileNameType.EMPLOYMENT_LETTER_PAY_SLIPS,
    viewValue: 'Employment Letter / Pay Slips',
    section: 'C',
  },
  [EEcddFormCAndU6FileNameType.TAX_RETURNS]: {
    id: EEcddFormCAndU6FileNameType.TAX_RETURNS,
    value: EEcddFormCAndU6FileNameType.TAX_RETURNS,
    viewValue: 'Tax Returns',
    section: 'C',
  },
  [EEcddFormCAndU6FileNameType.INVESTMENT_CERTIFICATES]: {
    id: EEcddFormCAndU6FileNameType.INVESTMENT_CERTIFICATES,
    value: EEcddFormCAndU6FileNameType.INVESTMENT_CERTIFICATES,
    viewValue: 'Investment Certificates',
    section: 'C',
  },
  [EEcddFormCAndU6FileNameType.PROPERTY_OWNERSHIP_DOCUMENTS]: {
    id: EEcddFormCAndU6FileNameType.PROPERTY_OWNERSHIP_DOCUMENTS,
    value: EEcddFormCAndU6FileNameType.PROPERTY_OWNERSHIP_DOCUMENTS,
    viewValue: 'Property Ownership Documents',
    section: 'C',
  },
  [EEcddFormCAndU6FileNameType.OTHERS_CHECKBOX_4]: {
    id: EEcddFormCAndU6FileNameType.OTHERS_CHECKBOX_4,
    value: EEcddFormCAndU6FileNameType.OTHERS_CHECKBOX_4,
    viewValue: 'Others',
    section: 'C',
  },
};


export const ECDD_FILE_TYPE_OPTIONS: Record<any, OptionDescription<any>> = {
  [EEcddAttachmentDocType.LETTER]: {
    id: EEcddAttachmentDocType.LETTER,
    value: EEcddAttachmentDocType.LETTER,
    viewValue: 'Letter Of Authorisation',
  },
  [EEcddAttachmentDocType.DOC_ID]: {
    id: EEcddAttachmentDocType.DOC_ID,
    value: EEcddAttachmentDocType.DOC_ID,
    viewValue: 'Identification Document',
  },
  [EEcddAttachmentDocType.ACRA_CERTIFICATE]: {
    id: EEcddAttachmentDocType.ACRA_CERTIFICATE,
    value: EEcddAttachmentDocType.ACRA_CERTIFICATE,
    viewValue: 'ACRA Certificate of Incorporation',
  },
};


export const DCDD_ACTION_AUDIT_OPTIONS: Record<any, OptionDescription<any>> = {
  [EDCDDActionAuditType.GET_THE_SIGNATURE_LINK]: {
    id: EDCDDActionAuditType.GET_THE_SIGNATURE_LINK,
    value: EDCDDActionAuditType.GET_THE_SIGNATURE_LINK,
    viewValue: 'Get the signature link',
  },
  [EDCDDActionAuditType.REGENERATE_ATTACHMENTS]: {
    id: EDCDDActionAuditType.REGENERATE_ATTACHMENTS,
    value: EDCDDActionAuditType.REGENERATE_ATTACHMENTS,
    viewValue: 'Regenerate Attachments',
  },
};
